import React from 'react';
import { Route } from 'react-router';

type Props = {
  path: string;
  view: any;
  permissionCallback?: () => boolean;
};

export default function ProtectedView({ path, view, permissionCallback }: Props) {
  if (permissionCallback && !permissionCallback()) {
    return null;
  }

  return <Route path={path} render={view} />;
}
